import { experiences } from "../data/experiences";
import Reveal from "../components/Reveal";
import Seo from "../components/Seo";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Experiences() {
  return (
    <div>
      <Seo
        title="Signature Experiences — Voyage Luxe"
        description="Private luxury tours, honeymoon journeys, desert glamping, yacht charters, wellness retreats, and VIP concierge — six experiences that define Voyage Luxe."
      />
      {/* Hero */}
      <section className="pt-40 md:pt-48 pb-16 md:pb-20 container-luxe">
        <div className="eyebrow mb-6">Signature Experiences</div>
        <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight text-balance max-w-5xl">
          Moments arranged with<br /><span className="italic">quiet precision</span>.
        </h1>
        <p className="mt-8 text-foreground/70 max-w-2xl leading-relaxed">
          Six experiences that define the Voyage Luxe way of travel — each crafted to feel less like an itinerary item and more like a private gift.
        </p>
      </section>

      {/* Editorial Sections - alternating */}
      {experiences.map((e, i) => {
        const reversed = i % 2 === 1;
        return (
          <section key={e.id} className={`py-16 md:py-24 ${i % 2 === 0 ? "bg-background" : "bg-secondary/40"}`}>
            <div className="container-luxe">
              <div className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center ${reversed ? "lg:[&>*:first-child]:order-2" : ""}`}>
                <Reveal className="lg:col-span-7">
                  <div className="aspect-[4/5] md:aspect-[5/6] overflow-hidden">
                    <img src={e.image} alt={e.title} className="h-full w-full object-cover hover:scale-105 transition-transform duration-[1500ms]" />
                  </div>
                </Reveal>
                <Reveal className="lg:col-span-5" delay={150}>
                  <div className="eyebrow text-accent mb-4">No. {String(i + 1).padStart(2, "0")} · {e.eyebrow}</div>
                  <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">{e.title}</h2>
                  <p className="mt-6 italic font-serif text-xl text-foreground/75">{e.short}</p>
                  <p className="mt-6 text-foreground/70 leading-relaxed">{e.description}</p>
                  <Link to="/contact" className="mt-10 inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] hover:text-accent transition-colors" data-testid={`exp-cta-${e.id}`}>
                    Arrange this experience <ArrowUpRight size={14} strokeWidth={1.5} />
                  </Link>
                </Reveal>
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
}
